<template>
  <div class="assets-calculator" :data-from-state="checkFormState" :data-submit-state="submitState">
    <div class="calculator-inputs-wrapper">
      <calculatorInputs :inputDetails="inputDetails" @sendCalculation="updateCalculation" :formState="checkFormState" :isEU="isEU"></calculatorInputs>
    </div>
    <div class="calculator-output-wrapper">
      <calculator-output name="tradeSize" :caption="this.$getContent('trade_size_output' , 'Trade Size')" :result="outputDetails.tradeSize"></calculator-output>
      <calculator-output name="tradeCost" :symbol="this.get_symbol(inputDetails.feeCurrency)" :caption="this.$getContent('trade_cost_output' , 'Trade Cost')" :result="outputDetails.tradeCost"></calculator-output>
      <calculator-output name="swapCost" :symbol="this.get_symbol(inputDetails.feeCurrency)" :caption="this.$getContent('swap_cost_output' , 'Swap Cost')" :result="outputDetails.swapCost"></calculator-output>
      <calculator-output name="total" :symbol="this.get_symbol(inputDetails.feeCurrency)" :caption="this.$getContent('total_output' , 'Total')" :result="outputDetails.total"></calculator-output>
    </div>
  </div>

</template>

<script>
	import calculatorInputs from './components/calculatorInputs/calculatorInputs.vue' ;
	import calculatorOutput from './components/calculatorOutput/calculatorOutput.vue' ;
	export default {
		name: "calculator",
		components: {
      calculatorInputs,
      calculatorOutput
    },
		data() {
			return {
				outputDetails: this.getOutputInitialValues(),
				inputDetails: {
          feeCurrency: '',
          asset: '',
          tradeSize: 0,
          positionDuration : 0,
          action : '',
          accountType: '',
          clientType: ''
        },
        isEU: this.getSitename() == 'eu',
        submitState: 'before'
			}
		},
		methods:{
			updateCalculation(){
				this.currentAsset = this.getAssetById(this.inputDetails.asset) ;
				let spreadCurrency = (this.currentAsset.category_name == 'FOREX') ? this.currentAsset.asset_name.substring(this.currentAsset.asset_name.length-3) : this.currentAsset.fee_currency ;
				if(this.currentAsset.fee_currency == this.inputDetails.feeCurrency && spreadCurrency == this.inputDetails.feeCurrency ){
					this.startCalculation(1 , 1) ;
				} else{
					this.getExchangeRate(this.inputDetails.feeCurrency ,spreadCurrency , this.currentAsset.fee_currency ) ;
				}
			},
			startCalculation(spreadExchangeRate , swapExchangeRate ){
				let asset = this.currentAsset ,
					swapVal = parseFloat( (this.inputDetails.action == 'buy')? asset.swap_bid  : asset.swap_ask),
					tradeSize = parseFloat(this.inputDetails.tradeSize),
					spread = parseFloat(asset.spread),
					positionDuration = parseFloat(this.inputDetails.positionDuration),
					tradeCost = (spread * tradeSize/spreadExchangeRate),
					swapCost = (positionDuration*tradeSize*swapVal/swapExchangeRate) ;

				this.outputDetails.tradeSize = tradeSize ;
				this.outputDetails.tradeCost = Math.round(tradeCost * 100) / 100 ;
				this.outputDetails.swapCost = Math.round(swapCost * 100) / 100  ;
				this.outputDetails.total = Math.round((this.outputDetails.tradeCost + this.outputDetails.swapCost)*100)/100 ;
				this.submitState = 'after' ;
			},
			getExchangeRate(fromCurrency , spreadCurrency , swapCurrency){
				let assetRate , rates , spreadRate , swapRate ;
				this.$http.get('https://v3.exchangerate-api.com/bulk/c78d5a0c6d5a8a4f00b83bc3/' + fromCurrency).then(response => {
					rates = JSON.parse(response.bodyText).rates;
					console.dir(rates) ;
					spreadRate = rates[spreadCurrency] ;
					swapRate = rates[swapCurrency] ;
					this.startCalculation(spreadRate , swapRate) ;
				}) ;
			},
			getAssetById(assetId){
        let assets = this.getAssets();
				for(let i=0 ;  i < assets.length ; i++){
					if(assets[i].asset_id == assetId){
						return assets[i];
					}
				}
				return false ;
      },
      getAssets() {
        let clientType = this.inputDetails['clientType'] || '';
        let accountType = this.inputDetails['accountType'] || '';
        let configKey = accountType;
        if (this.isEU) {
          configKey = clientType + '_' + accountType;
        }
        return siteAssetsConfig.items[configKey] || [];
      },
      getSitename() {
        return siteAssetsConfig.site_name || '';
      },
			get_symbol(currency){
				let symbols = {
					'USD': '$', // US Dollar
					'EUR': '€', // Euro
					'CRC': '₡', // Costa Rican Colón
					'GBP': '£', // British Pound Sterling
					'ILS': '₪', // Israeli New Sheqel
					'INR': '₹', // Indian Rupee
					'JPY': '¥', // Japanese Yen
					'KRW': '₩', // South Korean Won
					'NGN': '₦', // Nigerian Naira
					'PHP': '₱', // Philippine Peso
					'PLN': 'zł', // Polish Zloty
					'PYG': '₲', // Paraguayan Guarani
					'THB': '฿', // Thai Baht
					'UAH': '₴', // Ukrainian Hryvnia
					'VND': '₫', // Vietnamese Dong,
          'RUB' : '₽',
          'CHF' : '₣',
          'TRY' : '₺',
          'ZAR' : 'R'
				} ;

				return symbols[currency] || '' ;

			},
			isFormInputFilled(){
				let isFilled = true;
				for (let detail in this.inputDetails) {
          if (!this.isEU && detail == 'clientType') {
            continue;
          }

					if (!this.inputDetails[detail] || this.inputDetails[detail] == 'initial' || this.inputDetails[detail] == -1) {
						isFilled = false;
						break;
					}
				}

				return isFilled;
			},
			getOutputInitialValues(){
				return {tradeSize : 0 , tradeCost: 0  , swapCost : 0 , total: 0}  ;
			},
			resetOutputValues(){
				let tradeSizeElem = document.querySelector('.calculator-output-item[item-name="tradeSize"] h3') ;
				if(!!tradeSizeElem && tradeSizeElem.innerText !== '0'){
					this.outputDetails = this.getOutputInitialValues();
				}
			}
		},
		computed :{
			checkFormState(){
				this.submitState =  'before' ;
				// if a change was made in one of the inputs then need to reset the output values if it doesn't have initial values
				this.resetOutputValues();

				if(!this.isFormInputFilled()){
					return 'inComplete' ;
				}
				else{
					return 'completed' ;
				}
			}
		}
	}
</script>

<style lang="scss">
  .assets-calculator{
    color:#fff;
    font-family: Roboto;

    .calculator-inputs-wrapper{
      background-color: #212121;
      margin-bottom: 27px;
      border-radius: 6px;
    }

    .calculator-inputs {
      padding: 4% 6% 3.5%;

      @media (max-width: 938px){
        padding: 4.8% 4.5% 5.2%;
      }

      @media (max-width: 480px){
        padding: 8.8% 8%;
      }

      .input-number-wrapper , btn.dropdown-toggle{
        background-color: #353535;
        border-radius: 5px !important;
      }

      .client-type,
      .account-currency,
      .calculator-number-input {
        margin-bottom: 20px;
      }

      .calc-container {
        width: 45.6%;
        @media (max-width: 938px){
          width: 44.3%;
        }
        @media only screen and (max-width: 480px) {
          width: 100%;
        }
      }
    }

    label{
      font-size: 18px;
      margin-bottom: 5px;
      display: inline-block;
      font-weight: 300;
      @media (max-width: 480px){
        font-size: 16px;
      }
    }

    .calculator-action-btn{
      width: 245px;
      @media (max-width: 938px){
        width: 37.4%;
      }
      @media (max-width: 480px){
        width: 48.9%;
      }
    }

    .calculate-submit{
      width: 56.4%;
      margin: 0 auto;
      outline: none;
      display: block;
      margin-top: 32px;
      height: 50px;
      border-radius: 4px;
      background-color: #ffc900;
      border: none;
      color: #181818;
      font-size: 18px;

      &:not([disabled="disabled"]):hover{
        box-shadow: 0 10px 16px 0 rgba(255, 201, 0, 0.38);
      }

      &[disabled="disabled"]{
        background-color: #5a5a5a;
      }

      @media (max-width: 938px){
        width: 77.4%;
      }
      @media (max-width: 480px){
        width: 100%;
      }
    }

    .calculator-output-wrapper{
      display: -webkit-box;      /* OLD - iOS 6-, Safari 3.1-6 */
      display: -moz-box;         /* OLD - Firefox 19- (buggy but mostly works) */
      display: -ms-flexbox;      /* TWEENER - IE 10 */
      display: -webkit-flex;     /* NEW - Chrome */
      display: flex;

      @media (max-width: 480px){
        flex-wrap: wrap;
        padding: 0 8%;
        justify-content: space-between;
      }
      .calculator-output-item {
        width: 25%;
        @media (max-width: 480px){
          width: 49%;
        }
      }
    }

    input[type="number"]{
      -moz-appearance: textfield;
    }
    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
      -webkit-appearance: none ;
      margin: 0;
    }

    .calculate-submit{
      [disabled]{
        background-color: #ffc900;
      }
    }
  }


</style>



// WEBPACK FOOTER //
// src/calculator.vue